import EnvironmentSettings from './environment-settings';

export const environment: EnvironmentSettings = {
  production: false,

  hostNameEnglish: ['cfmh-dev-en.escolo.ca', ],
  hostNameFrench: ['cfmh-dev-fr.escolo.ca'],

  sessionTimeoutInSeconds: 300, // never expire

  //cmsApiProtocol: 'http:',
  //cmsApiHostName: 'dev-cfmh-cms-api.escolo.ca',
  cmsApiProtocol: 'https:',
  cmsApiHostName: 'app-cms-cfmh-uat.azurewebsites.net',
  cmsApiBasePath: '/api/resources/',

  itsrApiProtocol: 'https:',
  itsrApiHostName: 'app-compass-api-uat.azurewebsites.net',
  itsrApiBasePath: '/api/',

  subClassTotalPlan: 1077,
  subClassSystemsPlan: 1078,
  subClassAppliancePlan: 1079,
  googleAnalyticsTrackingId: "G-69J98SWDKG"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts